import { makeStyles } from "@material-ui/core";

export const useFullTweetStyles = makeStyles((theme) => ({
    header: {
        justifyContent: "space-between",
        "& .MuiTypography-h5": {
            display: "inline-block",
            verticalAlign: "middle"
        }
    },
    container: {
        position: "relative",
        borderTop: 0,
        borderLeft: 0,
        borderRight: 0,
        padding: "10px 22px 0px 22px"
    },
    blurContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1,
        padding: theme.spacing(2),
        backdropFilter: "blur(16px)",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        borderRadius: "8px",
        overflow: "hidden"
    },
    textBlurContainer: {
        fontSize: "24px",
        color: "#af0000"
    },
    tweetHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& a": {
            color: theme.palette.text.primary,
            textDecoration: "none"
        }
    },
    headerWrapper: {
        display: "flex"
    },
    headerUserInfo: {
        position: "relative",
        display: "flex",
        gap: 15
    },
    dateWrapper: {
        marginBottom: 16
    },
    textWrapper: {
        fontWeight: 400,
        marginTop: 16,
        marginBottom: 16,
        wordBreak: "break-word",
        "& #hashtag": {
            color: theme.palette.primary.main,
            fontSize: "23px"
        },
        "& #mention": {
            color: theme.palette.primary.main
        },
        "& #link": {
            textDecoration: "none",
            color: theme.palette.primary.main
        }
    },
    image: {
        "& img": {
            objectFit: "cover",
            // marginTop: 10,
            width: "100%",
            height: "100%"
            // borderRadius: 20,
            // borderColor: theme.palette.info.light
        },
        "& video": {
            objectFit: "cover",
            width: "100%",
            height: "100%"
        }
    },
    content: {
        display: "flex",
        alignItems: "center",
        margin: "16px 0"
    },
    contentItem: {
        marginRight: 20,
        "& span": {
            marginLeft: 5
        }
    },
    interactionCount: {
        "&:hover": {
            textDecoration: "underline",
            cursor: "pointer"
        }
    },
    info: {
        display: "flex",
        position: "relative",
        paddingTop: 5,
        paddingBottom: 5,
        margin: "0 auto",
        borderTop: `1px solid ${theme.palette.divider}`,
        left: 0,
        maxWidth: "100%",
        justifyContent: "space-around",
        padding: "2px 0",
        "& .MuiDivider-root": {
            color: "rgb(249, 243, 244)"
        }
    },
    replyInfoWrapper: {
        width: "100%",
        borderTop: 0,
        borderLeft: 0,
        borderRight: 0
    },
    replyInfo: {
        height: 72,
        backgroundColor: theme.palette.action.hover,
        margin: "16px 0px",
        borderRadius: 16,
        display: "flex"
    },
    iconWrapper: {
        padding: "20px 13px 16px 16px"
    },
    iconCircle: {
        marginRight: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main
    },
    icon: {
        "& svg": {
            marginTop: 3,
            height: "1.2em",
            fill: theme.palette.common.white
        }
    },
    replyTextInfoWrapper: {
        marginTop: 15,
        "& .MuiTypography-h6": {
            fontWeight: 700
        }
    },
    replyWrapper: {
        margin: "16px 60px",
        "& a": {
            textDecoration: "none",
            color: theme.palette.primary.main
        }
    },
    divider: {
        height: 12,
        backgroundColor: theme.palette.divider
    },
    "grid-layout-single": {
        display: "grid",
        gap: "3px",
        marginTop: 10,
        "& .image1": {
            gridColumn: "1 / span 2",
            gridRow: "1 / span 2"
        },
        "& img": {
            borderRadius: "20px"
        },
        "& video": {
            borderRadius: "20px"
        }
    },
    "grid-layout-double": {
        display: "grid",
        gap: "3px",
        marginTop: 10,
        gridTemplateColumns: "1fr 1fr", // Equal column widths
        gridTemplateRows: "1fr 1fr",
        "& .image1": {
            gridColumn: "1",
            gridRow: "1 / span 2",
            height: 400,
            "& img": {
                borderTopLeftRadius: "20px",
                borderBottomLeftRadius: "20px"
            },
            "& video": {
                borderTopLeftRadius: "20px",
                borderBottomLeftRadius: "20px"
            }
        },
        "& .image2": {
            gridColumn: "2",
            gridRow: "1 / span 2",
            "& img": {
                borderTopRightRadius: "20px",
                borderBottomRightRadius: "20px"
            },
            "& video": {
                borderTopRightRadius: "20px",
                borderBottomRightRadius: "20px"
            }
        }
    },
    "grid-layout-triple": {
        display: "grid",
        gap: "3px",
        marginTop: 10,
        gridTemplateColumns: "1fr 1fr", // Equal column widths
        gridTemplateRows: "1fr 1fr",
        "& .image1": {
            gridColumn: "1",
            gridRow: "1",
            height: 198.5,
            "& img": {
                borderTopLeftRadius: "20px"
            },
            "& video": {
                borderTopLeftRadius: "20px"
            }
        },
        "& .image2": {
            gridColumn: "1",
            gridRow: "2",
            height: 198.5,
            "& img": {
                borderBottomLeftRadius: "20px"
            },
            "& video": {
                borderBottomLeftRadius: "20px"
            }
        },
        "& .image3": {
            gridColumn: "2",
            gridRow: "1 / span 2",
            "& img": {
                borderTopRightRadius: "20px",
                borderBottomRightRadius: "20px"
            },
            "& video": {
                borderTopRightRadius: "20px",
                borderBottomRightRadius: "20px"
            }
        }
    },
    "grid-layout-quad": {
        display: "grid",
        gap: "3px",
        marginTop: 10,
        gridTemplateColumns: "1fr 1fr", // Equal column widths
        gridTemplateRows: "1fr 1fr",
        "& .image1": {
            gridColumn: "1",
            gridRow: "1",
            height: 220,
            "& img": {
                borderTopLeftRadius: "20px"
            },
            "& video": {
                borderTopLeftRadius: "20px"
            }
        },
        "& .image2": {
            gridColumn: "1",
            gridRow: "2",
            height: 220,
            "& img": {
                borderBottomLeftRadius: "20px"
            },
            "& video": {
                borderBottomLeftRadius: "20px"
            }
        },
        "& .image3": {
            gridColumn: "2",
            gridRow: "1",
            height: 220,
            "& img": {
                borderTopRightRadius: "20px"
            },
            "& video": {
                borderTopRightRadius: "20px"
            }
        },
        "& .image4": {
            gridColumn: "2",
            gridRow: "2",
            height: 220,
            "& img": {
                borderBottomRightRadius: "20px"
            },
            "& video": {
                borderBottomRightRadius: "20px"
            }
        }
    },
    "grid-layout-five": {
        display: "grid",
        gap: "3px",
        marginTop: 10,
        gridTemplateColumns: "1fr 1fr", // Equal column widths
        gridTemplateRows: "1fr 1fr",
        "& .image1": {
            gridColumn: "1",
            gridRow: "1",
            height: 220,
            "& img": {
                borderTopLeftRadius: "20px"
            },
            "& video": {
                borderTopLeftRadius: "20px"
            }
        },
        "& .image2": {
            gridColumn: "1",
            gridRow: "2",
            height: 220,
            "& img": {
                borderBottomLeftRadius: "20px"
            },
            "& video": {
                borderBottomLeftRadius: "20px"
            }
        },
        "& .image3": {
            gridColumn: "2",
            gridRow: "1",
            height: 220,
            "& img": {
                borderTopRightRadius: "20px"
            },
            "& video": {
                borderTopRightRadius: "20px"
            }
        },
        "& .image4": {
            gridColumn: "2",
            gridRow: "2",
            height: 220,
            position:"relative",
            "& img": {
                borderBottomRightRadius: "20px"
            },
            "& video": {
                borderBottomRightRadius: "20px"
            },
            "& .imageCountWrapper":{
                position:"absolute",
                top:0,
                left:0,
                right:0,
                bottom:0,
                height:"100%",
                width:"100%",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                backgroundColor:"#000000b5",
                borderBottomRightRadius: "20px",
            },
           "& .imageCount":{
                fontSize:50,
                color:"#FFFFFF",
            }
        },
    },
    // imageCountWrapper:{
    //     position:"absolute",
    //     top:0,
    //     left:0,
    //     right:0,
    //     bottom:0,
    //     height:"100%",
    //     width:"100%",
    //     display:"flex",
    //     alignItems:"center",
    //     justifyContent:"center",
    //     backgroundColor:"#00000057",
    // },
    // imageCount:{
    //     fontSize:24,
    //     color:"#FFFFFF",
    // }
}));
